import React from 'react';
import { Svg } from '../Svg';

export function CartItemSubscriptionDropdown(props) {
  const { selectedOption, setSelectedOption, options, updateSubscription } =
    props;

  const handleSelectChange = (event) => {
    const newSelectedOption = options.find(
      (option) => option.sellingPlan.id === event.target.value
    );
    setSelectedOption(newSelectedOption);
    updateSubscription(newSelectedOption);
  };

  const compareSellingPlans = (a, b) => {
    const frequencyA = a.sellingPlan.options[1].value.split('-')[0];
    const frequencyB = b.sellingPlan.options[1].value.split('-')[0];
    return frequencyA - frequencyB;
  };

  return (
    <div className="relative border border-[#E9E9EB] p-0 text-primary">
      <select
        id={`subscription-select-${selectedOption?.sellingPlan?.id
          .split('/')
          .pop()}`}
        className="h-9 w-full appearance-none pl-2 pr-4 text-[12px] font-medium bg-transparent"
        onChange={(event) => handleSelectChange(event)}
        value={selectedOption?.sellingPlan?.id}
      >
        {[...options].sort(compareSellingPlans).map((option) => {
          return (
            <option value={option.sellingPlan.id} key={option.sellingPlan.id}>
              {option.sellingPlan.name}
            </option>
          );
        })}
      </select>
      <Svg
        src="/svgs/select-chevrons.svg#select-chevrons"
        title="Select"
        viewBox="0 0 6 12"
        className="pointer-events-none absolute right-2 top-1/2 h-3 w-3 -translate-y-1/2 fill-current text-primary"
      />
    </div>
  );
}
